export const COLOR_FETCH = 'COLOR_FETCH';
export const COLOR_FETCHING = 'COLOR_FETCHING';
export const COLOR_FETCH_ERROR = 'COLOR_FETCH_ERROR';
export const COLOR_SAVE = 'COLOR_SAVE';
export const COLOR_SETUP_SET_COLOR_TYPE = 'COLOR_SETUP_SET_COLOR_TYPE';
export const COLOR_SET_SUCCESS = 'COLOR_SET_SUCCESS';
export const COLOR_RESET_SUCCESS = 'COLOR_RESET_SUCCESS';



// WEBPACK FOOTER //
// ./src/pages/serveditemsetup/state/colorsetup/types.js